import { Component, Output, EventEmitter, inject, input, output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Book, IBook } from '../../_models';
import { BookService } from '../../services/book.service';
import { AuthService } from '../../services/auth.service';
import { MdTransform } from '../../services/md-transform';
import { MatButtonModule } from '@angular/material/button';
import { NgFor, DatePipe } from '@angular/common';

@Component({
  selector: 'kbm-book-review',
  templateUrl: './book-review.component.html',
  styleUrls: ['./book-review.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    NgFor,
    DatePipe
  ]
})
export class BookReviewComponent {

  book = input.required<Book>();

  editClick = output<any>();

  route = inject(ActivatedRoute);
  router = inject(Router);
  authService = inject(AuthService);
  bookService = inject(BookService);

  crudStatus: string = 'REVIEW';
  mdt = MdTransform;

  constructor(
  ) { }


  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  onEditClick(e: Event) {
    this.editClick.emit(true);
  }

  backToList(): void {
    sessionStorage.removeItem('crudStatus');
    this.router.navigate([
      '/books'
    ]);
  }
}


